import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faChevronRight } from "@performyard/fontawesome/pro-regular-svg-icons";

import type { OrgEmployee } from "../types";

import { cx } from "../utils";

import css from "../OrgChart.module.scss";

export function BreadcrumbTrail({
	reportingChain,
	onNavigate,
}: {
	reportingChain: OrgEmployee[];
	onNavigate: (employeeId: string) => void;
}) {
	if (reportingChain.length === 0) return null;

	return (
		<div
			className={cx(
				css.breadcrumbTrail,
				"flex max-w-[min(520px,100%)] flex-wrap items-center gap-[3px] px-2 py-1.5"
			)}
		>
			{reportingChain.map((employee, index) => {
				const isCurrent = index === reportingChain.length - 1;
				return (
					<React.Fragment key={employee.id}>
						{index > 0 && <FontAwesomeIcon icon={faChevronRight} className="w-2.5 text-neutral-5" />}
						<button
							type="button"
							className={cx(
								"max-w-[150px] cursor-pointer overflow-hidden rounded-[5px] border-0 bg-transparent px-1.5 py-[3px] text-caption font-bold text-ellipsis whitespace-nowrap hover:bg-neutral-2 hover:text-primary-7",
								isCurrent ? "bg-primary-1 text-primary-7" : "text-neutral-7"
							)}
							onClick={() => onNavigate(employee.id)}
						>
							{employee.name}
						</button>
					</React.Fragment>
				);
			})}
		</div>
	);
}
